import { Button } from "reactstrap";
interface BtnProps extends React.ComponentProps<typeof Button> {
  children?: React.ReactNode;
}
function Btn(props: BtnProps) {
  return <Button {...props}>{props.children}</Button>;
};

export default Btn;